import { combineReducers } from 'redux'
import colorReducer from '../features/color/colorSlice'
import formDataReducer from '../features/formData/formDataSlice'

export default combineReducers({
    color: colorReducer,
    formData: formDataReducer
})

